import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {t} from 'shared/core';
import {endpoints, types} from 'main/tools';
import Employee from 'main/stores/employees/Employee';
import Cycle from 'main/stores/performance/Cycle';
import UiState from '../../../state/cycles/UiState';
import {successAlert} from 'shared/tools';

class CycleFlowState {
  store = new DomainStore();
  match;
  history;

  questionState = new UiState();
  allEmployees = [];
  cycle;
  errors = {};
  managerWelcomeModal = false;
  employeeWelcomeModal = false;
  managerReminderModal = false;
  employeeReminderModal = false;

  constructor() {
    makeAutoObservable(this, {
      store: false,
      history: false
    });
  }

  receiveProps({match, history}) {
    this.match = match;
    this.history = history;
  }

  async load() {
    const cycleId = this.match.params.id;
    await this.store._compose([
      endpoints.EMPLOYEES.ALL,
      endpoints.PERFORMANCE.CYCLE.with(cycleId),
      endpoints.COMPANY_EMAIL_TEMPLATES,
    ]);

    this.allEmployees = this.store.getAllOrdered(types.EMPLOYEE, Employee);
    this.cycle = this.createCycle(this.store._getSingle(types.PERFORMANCE.CYCLE));

    this.managerWelcomeEmailPreview = this.store._getSingle(types.COMPANY_EMAIL_TEMPLATE, {emailType: 'checkin_leader_welcome'});
    this.employeeWelcomeEmailPreview = this.store._getSingle(types.COMPANY_EMAIL_TEMPLATE, {emailType: 'checkin_employee_welcome'});
    this.employeeReminderEmailPreview = this.store._getSingle(types.COMPANY_EMAIL_TEMPLATE, {emailType: 'checkin_employee_reminder'});
  }

  createCycle(json) {
    const cycle = new Cycle(json);
    cycle.init(this.allEmployees);

    return cycle;
  }

  async onStepSubmitted({location}) {
    switch (location) {
      case 'name': return this.submitName();
      case 'leaders': return this.submitReviewers();
      case 'employees': return this.submitReviewees();
      case 'frequency': return this.submitFrequency();
      case 'questions': return this.submitQuestions();
      case 'review': return this.launchCycle();
      default:
        throw new Error(`Location ${location} is not supported`);
    }
  }

  async submitStep(props) {
    const cycle = this.cycle.pick(props);
    cycle.init(this.allEmployees);
    const {model, errors} = await this.store.patch(cycle);

    this.errors = errors;
    if (!model) return false;

    this.cycle = this.createCycle(model);
    return true;
  }

  async submitName() {
    return this.submitStep(['name']);
  }

  async submitReviewers() {
    return this.submitStep(['selectableReviewers']);
  }

  async submitReviewees() {
    return this.submitStep(['reviewers']);
  }

  async submitFrequency() {
    return this.submitStep(['frequency']);
  }

  async submitQuestions() {
    return this.submitStep(['questions']);
  }

  async launchCycle() {
    this.cycle.merge({complete: true});

    const modelUpdated = await this.submitStep(
      [
        'complete',
        'sendManagerWelcomeNotifications',
        'sendEmployeeWelcomeNotifications',
        'sendManagerNotifications',
        'sendEmployeeNotifications',
      ]
    );
    if (modelUpdated) {
      successAlert(t('performance.Check-In Cycle Successfully Created'));
      this.history.push(`/cycles/${this.match.params.id}/reviewees`);
    }
  }
}

export default CycleFlowState;
